import { render, staticRenderFns } from "./Infopanel.vue?vue&type=template&id=94a3d8ea&scoped=true"
import script from "./Infopanel.vue?vue&type=script&lang=js"
export * from "./Infopanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a3d8ea",
  null
  
)

export default component.exports